module.exports = __webpack_public_path__ + "img/img9.8e816ec2.png";